module.exports = __webpack_public_path__ + "img/XFs.ea8969a4.png";